import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  plusIcon, minusIcon
} from 'components/shared/Icons/Cart';
import { get } from 'lodash';
import SnackBar from 'ui/services/snackbar';
import { Clickable } from 'phoenix-components';
import { useRouter } from 'next/router';
import { useIsCustomDomain } from 'contexts/profile';
import { rulesCheckFromProps, getQuantity } from 'components/store/utils';
import styles from './Quantity.module.css';

function Quantity({ update, className, deleteOption, item, count, redirect = false }) {

  const config = get(item, 'quantityConfig', item.quantity);
  const itemQuantity = count;

  const quantitySchema =  {
    enabled: config.enabled,
    type: config.type,
    minQuantity: config.minQuantity,
    maxQuantity: config.maxQuantity,
    group: config.group,
  };

  const router = useRouter();
  const isCustomDomain = useIsCustomDomain();

  const type = get(quantitySchema, 'type', 'infinite');

  const isGroup = type === 'finite' && quantitySchema.group > 1 && redirect;

  const rulesToCheckAction = () => rulesCheckFromProps(count, item, quantitySchema);

  const getQuantityFromProps = (isDelete) => getQuantity(count, quantitySchema, isDelete);

  const onClick = () => {

    router.push({ pathname: isCustomDomain ? `/${item.slug}` : `/${item.shopSlug}/${item.slug}` });

  };


  return (
    <div className={cx(styles.container, className)}>
      {itemQuantity > 0 && (
        <Clickable
          className={cx(styles.min)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isGroup) {
              onClick();
              return;
            }
            if (itemQuantity > 1) {

              if (update) {

                update(itemQuantity - getQuantityFromProps(true));
          
              }
        
            }
            if (itemQuantity <= 1) {

              deleteOption(true);
        
            }
      
          }}
        >
          {minusIcon()}
        </Clickable>
      )}
      <span className={styles.num}>
        {' '}
        {itemQuantity > 0 ? itemQuantity : 'Add'}
      </span>
      <Clickable
        className={cx(styles.max)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isGroup) {
            onClick();
            return;
          }
          if (!rulesToCheckAction()) {
            const msg = `maximum quantity is ${quantitySchema.maxQuantity}`;
            SnackBar.showError(msg);
            return;
          }
          if (update) {

            update(itemQuantity + getQuantityFromProps());
            
          }
        
        }}
      >
        {plusIcon()}
      </Clickable>
    </div>
  );

}

Quantity.defaultProps = {
  update: null,
  className: '',
  deleteOption: null,
};

Quantity.propTypes = {
  update: PropTypes.func,
  className: PropTypes.string,
  deleteOption: PropTypes.func,
  item: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  redirect: PropTypes.bool.isRequired,
};

export default Quantity;
